import { render, staticRenderFns } from "./arrowUpIcon.vue?vue&type=template&id=6e4ff6bc&"
import script from "./arrowUpIcon.vue?vue&type=script&lang=js&"
export * from "./arrowUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports